<script lang="ts" setup>
import { defineProps } from 'vue';

defineProps<{
  title?: string
  description?: string
  image?: string
}>()
</script>

<template>
     <div class="bg-white px-2.5 py-20 md:px-20 lg:px-30 lg:py-40 max-w-1440 mx-auto">
        <h2 class="h3-bold mb-5 md:h2-bold lg:mb-20 text-center">{{ title }}</h2>
        <div class="flex flex-col gap-10 items-center xl:flex-row lg:gap-15 xl:items-start">
            <div class="flex-1">
                <img class="rounded-2.5" :src="image">
            </div>
            <div class="flex-1">
                <p class="" v-html="description"></p>
            </div>
        </div>
    </div>
</template>

<style lang="sass" scoped></style>
